import {
  BackgroundColors as ThemeBackgroundColors,
  BackgroundColors,
} from "@kameleon-util/global-theme";
import { LayoutOptions } from "../helpers/prop-types-helper";

export const BackgroundColor = {
  backgroundColor: LayoutOptions.List([
    BackgroundColors.neutralLight,
    BackgroundColors.neutral,
    ThemeBackgroundColors.dark,
    BackgroundColors.darkest,
  ]) as string[],
};
